var _circle, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconMobileApp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 70,
    viewBox: "0 0 70 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 35,
    cy: 35,
    r: 35,
    fill: "#FF5A26"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.3397 15.5774L35 11.1547L42.6603 15.5774V24.4227L35 28.8453L27.3397 24.4227V15.5774Z",
    stroke: "white",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27 15.5L35 20M35 20V29.5M35 20L43 15.5",
    stroke: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M27 43L35 47.5M35 47.5V57M35 47.5L43 43",
    stroke: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M27.3397 43.5774L35 39.1547L42.6603 43.5774V52.4227L35 56.8453L27.3397 52.4227V43.5774Z",
    stroke: "white",
    strokeWidth: 2
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M9 29L17 33.5M17 33.5V43M17 33.5L25 29",
    stroke: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M9.33975 29.5774L17 25.1547L24.6603 29.5774V38.4227L17 42.8453L9.33975 38.4227V29.5774Z",
    stroke: "white",
    strokeWidth: 2
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M45 29L53 33.5M53 33.5V43M53 33.5L61 29",
    stroke: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M45.3397 29.5774L53 25.1547L60.6603 29.5774V38.4227L53 42.8453L45.3397 38.4227V29.5774Z",
    stroke: "white",
    strokeWidth: 2
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M21 36.5L27.5 40.5M30.5 22.5L24.5 26M39.5 22.5L45.5 26M42.5 40L49 36",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMobileApp);
export default __webpack_public_path__ + "static/media/iconMobileApp.9d81090491ba2e1afbabbadad9c5639f.svg";
export { ForwardRef as ReactComponent };